var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgZoom = function SvgZoom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 18.8404L18.8094 15.0702C19.4975 13.6992 19.9562 12.0997 19.9562 10.5002C19.9562 5.13052 15.5984 0.789062 10.2086 0.789062C4.8187 0.789062 0.460938 5.13052 0.460938 10.5002C0.460938 15.8699 4.8187 20.2114 10.2086 20.2114C11.8141 20.2114 13.4195 19.7544 14.7957 19.0689L18.5801 22.8391C19.7268 23.9816 21.447 23.9816 22.5938 22.8391C23.6259 21.6966 23.6259 19.9829 22.5938 18.8404ZM10.2086 17.9264C6.08016 17.9264 2.7545 14.6132 2.7545 10.5002C2.7545 6.38726 6.08016 3.07404 10.2086 3.07404C14.337 3.07404 17.6626 6.38726 17.6626 10.5002C17.6626 14.6132 14.337 17.9264 10.2086 17.9264Z",
    fill: "#828282"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZoom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom.6a18a59c.svg";
export { ForwardRef as ReactComponent };